<template>
  <div class="qr-lookup main">
    <div class="centered">
      <div v-if="error">
        <p class="has-text-danger is-size-3" style="padding: 10px">
          {{ error }}
        </p>
        <button class="button is-link is-rounded" @click="goHome">
          Back to TUK
        </button>
      </div>
      <div v-else>
        <div class="centered tuk-icon" />
        <half-circle-spinner
          :animation-duration="1200"
          :size="190"
          color="#209CEE"
        />
        <!-- :size="loaderSize" -->
      </div>
    </div>
  </div>
</template>


<script>
import EventBus from "../eventBus";
import { HalfCircleSpinner } from "epic-spinners";
import api from "../apisTuk.js";

export default {
  name: "QRLookup",
  components: {
    HalfCircleSpinner,
  },
  data() {
    return {
      loaderSize: Math.min(window.innerWidth * 0.75, window.innerHeight * 0.75),
      error: null,
    };
  },
  mounted() {
    this.$cookies.set("full_path", this.$route.fullPath);
    const id = this.$route.params.id;
    this.console("QR Code ID: " + id);
    if (id === "install") return this.installRedirect();

    // this should return a full data object from API
    // then will execute the logic, e.g. action, path etc
    const obj = this.lookupQRCodePath(id);
    var objString = JSON.stringify(obj);
    EventBus.$emit("DEBUG", `qr code: ${id}, obj: ${objString}`);
    this.$cookies.set("last_qr_code", id);
    // store array of all QR codes run in cookies

    var type = typeof obj;
    if (obj == null) {
      this.console("obj is null, show error message and do nothing");
    } else if (type === "string") {
      this.$router.push(obj);
    } else if (type === "object") {
      // alert("parse object: " + JSON.stringify(obj));
      var redirect = this.handleQRObject(obj);
      if (redirect !== "") {
        // redirect if not empty string
        EventBus.$emit("DEBUG", `redirect to: ${redirect}`);
        setTimeout(() => this.$router.push(redirect), 1000);
      }
    } else {
      alert(`obj type not handled: ${type}`);
    }
  },
  methods: {
    isFraudulent() {
      return Math.random() < 0.3;
    },
    installRedirect() {
      setTimeout(() => {
        if (this.isIOSApp()) {
          this.goHome(); // already in iOS app
        } else if (this.$store.getters.getOS === "iOS") {
          window.location = "https://apps.apple.com/app/tuk/id1493367124?ls=1";
        } else {
          window.location = "http://bit.ly/TUKAPPGOOG"; // Google Play Store
        }
      }, 1000);
    },
    handleQRObject(o) {
      this.console("handle QR Object!");
      if (o.action.name === "call_phone") {
        window.location.href = `tel:${o.action.phone_number}`;
        this.error = o.action.message;
        return o.redirect;
      }
      if (o.action.name === "add_role") {
        this.console("ACTION add_role");
        // api post to add_role endpoint
        var data = {
          user_id: this.$cookies.get("user").user.id,
          business_id: o.action.business_id,
          workflow_name: o.action.workflow_name,
          role_type: o.action.role_type,
        };
        api.rolesPost(data); // this should use store.dispatch
        this.error = o.action.message;
        return o.redirect;
      }
      this.error = `Invalid action name: ${o.action.name}`;
    },
    // this should look up in DB
    // each QR ID will have a data model including:
    // action, business_id, customer_id, role, requires_location,
    // requires_passcode, redirect_path, time_validity (created_at and duration),
    // single_use, recaptcha
    // << could also chain together multiple actions
    lookupQRCodePath(id) {
      if (id === "a") {
        if (this.isFraudulent()) {
          this.console("check fake");
          // this.error = "Incorrect Location!";
          // return null;
        }
        return "/profile?action=add&business_id=raintree&role=driver";
      }
      if (id === "b") {
        return "/profile?action=add&business_id=raintree&role=customer";
      }
      if (id === "c") {
        return "/tuktuk";
      }
      if (id === "d") {
        // window.location.href = "tel:+66909588716";
        // this.error = "Calling the TUK help line...";
        // return null;
        return {
          action: {
            name: "call_phone",
            phone_number: "+66909588716",
            message: "Calling the TUK help line...",
          },
          requirements: ["is_logged_in"],
          redirect: "",
        };
      }
      if (id === "e") {
        // raintree tuktuk customer
        return {
          action: {
            name: "add_role",
            role_type: "customer",
            business_id: "raintree",
            workflow_name: "tuktuk",
            message: "You've been added to the Raintree Village Tuk Tuk!",
          },
          // if role already exists then jump straight to booking
          requirements: ["is_logged_in"],
          redirect: "/tuktuk?request_ride=true",
        };
      }
      if (id === "f") {
        // raintree tuktuk driver
        return {
          action: {
            name: "add_role",
            role_type: "driver",
            business_id: "raintree",
            workflow_name: "tuktuk",
            message: "You're a driver of the Raintree Village Tuk Tuk!",
          }, // also add business as the workplace
          // if role already exists then jump straight to start_work prompt on /tuktuk page
          requirements: ["is_logged_in"],
          redirect: "/tuktuk?start_work=true",
        };
      }
      if (id === "g") {
        // raintree tuktuk customer + stop 3
        return {
          action: {
            name: "add_role",
            role_type: "customer",
            business_id: "raintree",
            workflow_name: "tuktuk",
            message: "You've been added to the Raintree Village Tuk Tuk!",
          },
          // if role already exists then jump straight to booking
          requirements: ["is_logged_in"],
          redirect: "/tuktuk?request_ride=true&stop=c",
        };
      }
      // otherwise QR ID is invalid
      this.error = "Invalid Code"; //"Invalid QR Code!";
      return null;
    },
  },
};
</script>

<style scoped>
.main {
  background-color: #fac002;
  width: 100%;
  height: 100%;
}
.centered {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.tuk-icon {
  background-image: url("../../public/img/icons/round-512x512.png");
  position: absolute;
  /* height: min(50vw, 50vh);
  width: min(50vw, 50vh); */
  height: 150px;
  width: 150px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>